import { differenceInDays, format, isBefore, isValid, parse, startOfDay } from "date-fns";

const isDateBeforeToday = (date: Date): boolean => isBefore(date.getTime(), new Date().getTime());

const calculateDaysToInStock = (inStockDate: Date): number => {
  const startOfToday = startOfDay(new Date());

  return differenceInDays(inStockDate, startOfToday);
};

interface ExpectedReturnDate {
  isValid: boolean;
  returnDate: string;
  daysToReturn: number;
}

const expectedReturnDateFormat = "yyyy-MM-dd HH:mm:ss xx";

const getExpectedReturnDate = (returnDate = ""): ExpectedReturnDate => {
  const inStockDate = parse(returnDate, expectedReturnDateFormat, new Date());

  if (!isValid(inStockDate) || isDateBeforeToday(inStockDate)) {
    return {
      isValid: false,
      returnDate: "",
      daysToReturn: 0,
    };
  }

  return {
    isValid: true,
    returnDate: format(inStockDate, "MMM d"),
    daysToReturn: calculateDaysToInStock(inStockDate),
  };
};

export { getExpectedReturnDate, expectedReturnDateFormat };
